<div class="small-box" [ngClass]="boxClass">
  <div class="small-box-header">
    <p class="p-mt-5">{{ description | translate }}</p>
  </div>
  <div class="inner">
    <h3>{{ totalCount | number }}</h3>
  </div>
</div>
